import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  public ValidEmail = new UntypedFormControl('', Validators.compose([
    Validators.required,
    Validators.pattern(/^\S+@\S+\.\S+$/)]));

  IsPassword1Valid = new UntypedFormControl('', Validators.compose([
    this.checkPasswordOne()]));

  IsPassword2Valid = new UntypedFormControl('', Validators.compose([
    this.checkPasswordTwo()]));

  public IsPasswordVisible = false;
  public IsConfirmationPasswordVisible = false;

  public email: string;
  public pwd1: string;
  public pwd2: string;

  private key: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private dialog: MatSnackBar) {

    this.key = this.route.snapshot.params['key'];
    if (!this.key) {
      this.router.navigate([ENavigationRoute.Error]);
    }
  }

  ngOnInit(): void {

  }

  onPWD1KeyUpEvent($event) {
    this.IsPassword2Valid.updateValueAndValidity();
  }

  onPWD2KeyUpEvent($event) {
    this.IsPassword1Valid.updateValueAndValidity();
  }

  checkPasswordOne(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      this.IsPassword1Valid && this.IsPassword1Valid.value && this.IsPassword1Valid.value.length >= 8 &&
        control.value === this.IsPassword2Valid.value
        ? null : { wrongColor: control.value };
  }

  checkPasswordTwo(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      this.IsPassword2Valid && this.IsPassword2Valid.value && this.IsPassword1Valid.value.length >= 8 &&
        control.value === this.IsPassword1Valid.value
        ? null : { wrongColor: control.value };
  }

  CanAskNewPassword() {
    return this.email && this.pwd1 && this.pwd2 && this.pwd1 === this.pwd2
      && this.IsPassword1Valid.valid
      && this.IsPassword2Valid.valid
      && this.ValidEmail.valid;
  }

  resetPassword() {
    this.userService.resetPassword(this.email, this.key, this.pwd1).subscribe(x => {
      if (x) {
        NotificationManager.handleSuccess('Mot de passe modifié !', this.dialog);
        this.router.navigate([ENavigationRoute.Login], { replaceUrl: true });
      }
    })
  }
}
